module.exports = __webpack_public_path__ + "img/41.5.COD.badb74a7.png";